export default __webpack_public_path__ + "static/media/medium-icon.62316ebc.png";